import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { JSONTree } from 'react-json-tree';
import { useOktaAuth } from "@okta/okta-react";
import {fetchAPI} from "../Services/BradyAPI";
import {useState, useEffect } from "react";
import CodeCopyButton from "../Components/CodeCopyButton";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
//import prism from 'react-syntax-highlighter/dist/esm/styles/prism/prism';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';


// const Results = (props) => {
//     return (
//         <div>{props.children}</div>
//     )
// }

const TestAPI = () => {
    const { authState, oktaAuth } = useOktaAuth();
    const [apiEndPoint, setApiEndPoint] = useState({
        endpoint: "",
        expectedResponse: ""
    });
    const [results, setResults] = useState({
        show: false,
        success: false,
        serverError: null,
        statuscode: 0,
        message: null,
        endpoint: "",
        responsetype: "",
        data: null
    })


    let token = authState?.isAuthenticated ? authState.accessToken.accessToken : "";

    // const prom = async () => {
    //     const r = await fetchAPI(apiEndPoint.endpoint,apiEndPoint.expectedResponse, token)
    //     console.log(r);
    //     return r;
    // };
    // prom();
let displayComponent;

    useEffect(() => {
        const prom = async () => {
            const r = await fetchAPI(apiEndPoint.endpoint,apiEndPoint.expectedResponse, token)
            console.log(r);
            setResults(r);
        };
        prom();
    },[apiEndPoint, token]);

    switch(true) {
        case !results.show:
            displayComponent = <div>no content</div>
            break;
        case (results.show && results.success):
            displayComponent = (
                <Card className='success-return' style={{ margin: "1em auto" }}>
                    <Card.Header className="version2">Success: {results.endpoint}  {results.responsetype === "string" && <CodeCopyButton>{results.data}</CodeCopyButton>}</Card.Header>
                    <Card.Body>
                        {results.responsetype === "json" && <JSONTree data={results.data}></JSONTree>}
                        {results.responsetype === "string" && <SyntaxHighlighter style={dark}>{results.data}</SyntaxHighlighter>}
                    </Card.Body>
                </Card>
                )
                break;
            case (results.show && !results.success && results.serverError):
                displayComponent =  (
                    <Card className='error-return' style={{ margin: "1em auto" }}>
                        <Card.Header>Server Error - Status Code: {results.statuscode.toString()} -  {results.endpoint}</Card.Header>
                        <Card.Body>
                            {!results.message ? "" : `Messsage: ${results.message};`}
                            <br/>
                            {`Headers in console`}
                        </Card.Body>
                    </Card>
                )
                break;
            case (results.show && !results.success && !results.serverError):
                displayComponent =  (
                    <Card className='error-return' style={{ margin: "1em auto" }}>
                        <Card.Header>Unhandled Error - {results.endpoint}</Card.Header>
                        <Card.Body>
                            {!results.message ? "" : `Messsage: ${results.message};`}
                            <br/>
                            {`Headers in console`}
                        </Card.Body>
                    </Card>
                    )
                    break;
            default:
                displayComponent =  <div>no content</div>
        }

  return (
    <Container>
        <br/><br/>
        <Row>
            <Col className="text-center">
                <h3>API Test Calls</h3>
                <p>For full API details, refer to the Swagger UI. Authentication is required for all endpoints expect Authtest/Hello</p>
            </Col>
        </Row>
        <Row>
            <Col sm={3}>
                <Card style={{ margin: "1em auto", height: "200px" }}>
                    <Card.Header>api/AuthTest/hello</Card.Header>
                    <Card.Body>
                        <ul>
                            <li><strong>Purpose:</strong> Test connection to API</li>
                            <li><strong>Authentication:</strong> Not Required</li>
                            <li><strong>Result:</strong> Returns a string</li>
                        </ul>
                        <Button onClick={() => {
                            setApiEndPoint({
                                endpoint:'AuthTest/hello',
                                expectedResponse: "string"
                            })
                            }}>Execute</Button>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3}>
                <Card style={{ margin: "1em auto", height: "200px" }}>
                    <Card.Header>api/AuthTest/whoami</Card.Header>
                    <Card.Body>
                        <ul>
                            <li><strong>Purpose:</strong> Test API Authentication</li>
                            <li><strong>Authentication:</strong> Required</li>
                            <li><strong>Result:</strong> 401 or JSON Object</li>
                        </ul>
                        <Button onClick={() => {
                            setApiEndPoint({
                                endpoint:'AuthTest/whoami',
                                expectedResponse: "json"
                            })
                        }}>Execute</Button>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3}>
                <Card style={{ margin: "1em auto", height: "200px" }}>
                    <Card.Header>api/lookup/all</Card.Header>
                    <Card.Body>
                        <ul>
                            <li><strong>Purpose:</strong> Test API</li>
                            <li><strong>Authentication:</strong> Required</li>
                            <li><strong>Result:</strong> JSON Object</li>
                        </ul>
                        <Button onClick={() => {
                            setApiEndPoint({
                                endpoint:'lookup/all',
                                expectedResponse: "json"
                            })
                        }}>Execute</Button>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3}>
                <Card style={{ margin: "1em auto", height: "200px" }}>
                    <Card.Header>api/masterkey/#</Card.Header>
                    <Card.Body>
                        <ul>
                            <li><strong>Purpose:</strong> Test API</li>
                            <li><strong>Authentication:</strong> Required</li>
                            <li><strong>Result:</strong> JArray</li>
                        </ul>
                        <Button onClick={() => {
                            setApiEndPoint({
                                endpoint:'masterkey/7?includedeleted=true',
                                expectedResponse: "json"
                            })
                        }}>Execute</Button>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6}>
                <Card style={{ margin: "1em auto", height: "200px" }}>
                    <Card.Header>Get Token</Card.Header>
                    <Card.Body>
                        <p>For use in Swagger UI after authentication required for more endpoints. <strong>Authentication is required.</strong></p>
                        <Button onClick={() => {
                            setApiEndPoint({
                                endpoint:'Get Authentication Token',
                                expectedResponse: "token"
                            })
                        }}>Execute</Button>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        <br/><br/>
        <Row>
            <Col sm={12} className="text-center">
                <h3>Results</h3>
            </Col>
        </Row>
        <Row>
            <Col sm={12} className="">
                {displayComponent}
            </Col>
        </Row>
    </Container>
  );
};

export default TestAPI;